import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router);

const createRouter = () => new Router({
	// mode: 'history',
	routes: [{ //会员门户网站
			path: '/',
			component: () => import('@/views/login'),
		}, {
			path: '/forget',
			component: () => import('@/views/login/forget.vue')
		},{
		path: '/register',
		component: () => import('@/views/register/index.vue')
	},
		{
			path: '/register',
			component: () => import('@/views/register'),
		}, {
			path: '/index',
			component: () => import('@/views/index/index.vue'),
			meta: {
				requireAuth: true
			},
			redirect: to => {
				// 方法接收目标路由作为参数
				// return 重定向的字符串路径/路径对象
				return {
					path: '/home',
				}
			},
			children: [{ //首页
				path: '/home',
				name: 'home',
				redirect: to => {
					return {
						path: '/infochange'
					}
				},
				component: () => import('@/views/home/index.vue'),
				children: [{ //项目管理
					path: '/basicinfo',
					name: 'basicinfo',
					component: () => import('@/views/home/basicinfo.vue'),
					meta: {
						activeMenu: '/basicinfo',
						requireAuth: true
					}
				}, { //申请发票
					path: '/applyinvoice',
					name: 'applyinvoice',
					component: () => import('@/views/home/applyinvoice.vue'),
					meta: {
						activeMenu: '/basicinfo',
						requireAuth: true
					}
				}]
			}, { //项目申报
				path: '/infochange',
				component: () => import('@/views/infochange/index.vue'),
				children: [{ //项目申报
					path: '/infochange',
					name: 'infochange',
					component: () => import('@/views/infochange/infochange.vue'),
					meta: {
						activeMenu: '/infochange',
						requireAuth: true
					}
				}, { //新增
					path: '/infoadd',
					name: 'infoadd',
					component: () => import('@/views/infochange/infoadd.vue'),
					meta: {
						activeMenu: '/infochange',
						requireAuth: true
					}
				},
					{ //新增
						path: '/addGf',
						name: 'addGf',
						component: () => import('@/views/infochange/addGf.vue'),
						meta: {
							activeMenu: '/addGf',
							requireAuth: true
						}
					},

					{ //详情
					path: '/infodetail',
					name: 'infodetail',
					component: () => import('@/views/infochange/infodetail.vue'),
					meta: {
						activeMenu: '/infochange',
						requireAuth: true
					}
				},{//诚信企业
					path: '/creditEnterprise',
					name: 'creditEnterprise',
					component: () => import('@/views/infochange/creditEnterprise.vue'),
					meta: {
						activeMenu: '/infochange',
						requireAuth: true
					}
				},{//诚信企业---2026
					path: '/creditEnterprise2026',
					name: 'creditEnterprise2026',
					component: () => import('@/views/infochange/creditEnterprise_2026/index.vue'),
					meta: {
						activeMenu: '/infochange',
						requireAuth: true
					}
				},{
				//	诚信企业详情1
					path: '/creditEnterDetail',
					name: 'creditEnterDetail',
					component: () => import('@/views/infochange/creditEnterDetail.vue'),
					meta: {
						activeMenu: '/infochange',
						requireAuth: true
					}
				},{
					//	诚信企业详情2026
						path: '/creditEnterDetail2026',
						name: 'creditEnterDetail2026',
						component: () => import('@/views/infochange/creditEnterprise_2026/creditEnterDetail.vue'),
						meta: {
							activeMenu: '/infochange',
							requireAuth: true
						}
					}]
			}, { //申报管理
				path: '/contribute',
				component: () => import('@/views/contribute/index.vue'),
				children: [{
					path: '/contribute',
					component: () => import('@/views/contribute/contribute.vue'),
					meta: {
						activeMenu: '/contribute',
						requireAuth: true
					}
				}, {
					path: '/newcontribute',
					name: 'newcontribute',
					component: () => import('@/views/contribute/newcontribute.vue'),
					meta: {
						activeMenu: '/contribute',
						requireAuth: true
					}
				},{
					//	诚信企业详情1
					path: '/creditEnterDetail',
					name: 'newCreditEnterDetail',
					component: () => import('@/views/contribute/creditEnterDetail.vue'),
					meta: {
						activeMenu: '/contribute',
						requireAuth: true
					}
				}]

			}, { //基本信息
				path: '/mrecord',
				component: () => import('@/views/m-record/index.vue'),
				children: [{
					path: '/mrecord',
					component: () => import('@/views/m-record/m-record.vue'),
					meta: {
						activeMenu: '/mrecord',
						requireAuth: true
					}
				}, {
					path: '/mrecordetail',
					component: () => import('@/views/m-record/m-recordetail.vue'),
					meta: {
						activeMenu: '/mrecord',
						requireAuth: true
					}
				}]
			}, {
				//修改密码
				path: '/changepassword',
				component: () => import('@/views/changepassword/index.vue'),
				meta: {
					requireAuth: true
				}
			}]
		},
	]
})

const router = createRouter();

router.beforeEach((to, from, next) => {
	// console.log('to', to)
	// console.log('from', from)
	if (to.matched.length != 0) {
		// console.log('length不为0')
		if (to.meta.requireAuth) { //判断该路由是否需要登录权限
			// console.log('需要权限')
			if (Boolean(localStorage.getItem('token'))) { //通过浏览器本地缓存判断当前的token是否存在
				// console.log('有token')
				next()
			} else {
				if (from.fullPath == '/') {
					next('/')
				} else {
					next({
						path: '/',
					})
				}
			}
		} else {
			// console.log('不需要权限')
			if (Boolean(localStorage.getItem('token'))) { //判断是否登录
				if (to.path != '/') { //判断是否要跳到登录页面
					next();
				} else {
					/*
					 * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的页面
					 */
					next({
						path: '/index'
					})
				}
			} else {
				// console.log('没有权限验证 没有token')
				next()
			}
		}
	} else {
		next({
			path: '/login',
			query: {
				redirect: to.fullPath
			}
		})
	}
})

const originalPush = Router.prototype.replace
Router.prototype.replace = function replace(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch(err => err)
}

export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // the relevant part
}

export default router;
